module.exports = __webpack_public_path__ + "img/content5.e0caf818.png";